export const TCAT_711PICKUP_DESTINATION_TYPES = {
  TW_TCAT_711PICKUP_ROOMTEMP_EMAP_ONLY: 'tw_tcat_711pickup_roomtemp_emap_only',
  TW_TCAT_711PICKUP_REFRIGERATED_EMAP_ONLY:
    'tw_tcat_711pickup_refrigerated_emap_only',
  TW_TCAT_711PICKUP_FROZEN_EMAP_ONLY: 'tw_tcat_711pickup_frozen_emap_only',
  SL_LOGISTICS_TCAT_711PICKUP_ROOMTEMP: 'sl_logistics_tcat_711pickup_roomtemp',
  SL_LOGISTICS_TCAT_711PICKUP_REFRIGERATED:
    'sl_logistics_tcat_711pickup_refrigerated',
  SL_LOGISTICS_TCAT_711PICKUP_FROZEN: 'sl_logistics_tcat_711pickup_frozen',
};

export const DESTINATION_TYPES = {
  ADDRESS: 'address',
  SAVE_ADDRESS: 'save_address',
  STORE_PICK_UP: 'store_pickup',
  SF_PLUS_LOCKER: 'sf_plus_locker',
  SF_EXPRESS_LOCKER: 'sf_express_locker',
  STORE_MAP_7_11: 'store_map_7_11',
  SAVE_STORE_MAP_7_11: 'save_store_map_7_11',
  STORE_MAP_FAMILY_MART: 'store_map_family_mart',
  SAVE_STORE_MAP_FAMILY_MART: 'save_store_map_family_mart',
  STORE_MAP_FAMILY_MART_FROZEN: 'store_map_family_mart_frozen',
  ZEEK: 'zeek',
  SKIP_DESTINATION: 'skip_destination',
  ...TCAT_711PICKUP_DESTINATION_TYPES,
};

export const DESTINATION_TYPES_V2 = {
  ADDRESS: 'address',
  STORE_PICK_UP: 'store_pickup',
  SF_PLUS_LOCKER: 'sf_plus_locker',
  SF_EXPRESS_LOCKER: 'sf_express_locker',
  STORE_MAP_7_11: 'store_map_7_11',
  SAVE_STORE_MAP_7_11: 'save_store_map_7_11',
  STORE_MAP_FAMILY_MART: 'store_map_family_mart',
  SAVE_STORE_MAP_FAMILY_MART: 'save_store_map_family_mart',
  STORE_MAP_FAMILY_MART_FROZEN: 'store_map_family_mart_frozen',
  NO_DESTINATION_DISPLAY: 'no_destination_display',
  ...TCAT_711PICKUP_DESTINATION_TYPES,
};
